export class Orders {
  public orderId: string = '';
  public orderDate: Date;
  public orderStatus: string = 'Preparing';
  public invoiceNumber: string;
  public orderTotal: number = 0;
  public orderSubTotal: number = 0;
  public terminalId: string;
  public isEditable: boolean = false;
  public comments: string;
  public terms: string;
  public source: string;
  public customerId: number = 0;
  public createdBy : number = 0;
  public createdDate : string;
  public updatedBy : number = 0;
  public updatedDate : string;

  public orderAdjustments : OrderAdjustments[];
  public orderItems : OrderItems[];

  //processed property
  public allAdjustments: AllAdjustments[];
}

export class OrderItems {
  public lineId: string;
  public itemName: string;
  public unitPrice: number = 0;
  public quantity: number = 0;
  public itemId: number = 0;
  public itemVariationId: number = 0;
  public itemVariationName :string;
  public barcode: string;
  public orderId: string;
  public lineTotal: number;
  public itemAdjustments: ItemAdjustments[];
}

export class OrderAdjustments {
  public id: number;
  public orderId: string;
  public adjustmentType: string;
  public adjustmentName: string;
  public amount: number = 0;
  public percentValue: number = 0;
}

export class ItemAdjustments {
  public orderId: string;
  public lineId: string;
  public adjustmentType: string;
  public adjustmentName: string;
  public amount: number = 0;
}

//for displaying purpose
//sum of all item adjustments and the order adjustments
export class AllAdjustments {
  public orderId: string;
  public adjustmentType: string;
  public adjustmentName: string;
  public amount: number = 0;
}
